import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { HStack, Text, VStack } from '@chakra-ui/react';
import { Icon, List, ModalVariants } from '@whitbread-eos/atoms';
import { formatAssetsUrl, useSemanticTypography } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FacilitiesModal(_ref) {
  var facilities = _ref.facilities,
    isModalVisible = _ref.isModalVisible,
    onModalClose = _ref.onModalClose,
    containerRef = _ref.containerRef;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var getTypographyProps = useSemanticTypography();
  var facilityItemTypographyProps = getTypographyProps({}, facilityItemSemanticTypography);
  var facilitiesModalTitleTypographyProps = getTypographyProps(facilitiesModalTitleLegacyTypography, facilitiesModalTitleSemanticTypography);
  var facilitiesModalHeaderStyles = {
    sx: {
      '& [data-testid="facilities-modal-ModalTitle"]': _objectSpread({}, facilitiesModalTitleTypographyProps)
    }
  };
  return _jsx(ModalVariants, _objectSpread(_objectSpread({
    isOpen: isModalVisible,
    onClose: onModalClose,
    dataTestId: "facilities-modal",
    variant: "info",
    variantProps: {
      title: t('facilities.modal.title'),
      delimiter: true
    },
    headerStyles: facilitiesModalHeaderStyles
  }, containerRef && {
    portalProps: {
      containerRef
    }
  }), {}, {
    children: _jsx(VStack, _objectSpread(_objectSpread({}, modalStyles), {}, {
      children: _jsx(List, _objectSpread(_objectSpread({
        "data-testid": "facilities-list"
      }, listStyles), {}, {
        children: facilities === null || facilities === void 0 ? void 0 : facilities.map(facility => _jsxs(HStack, {
          spacing: "1.5rem",
          children: [_jsx(Icon, {
            src: formatAssetsUrl(facility === null || facility === void 0 ? void 0 : facility.icon),
            w: "6"
          }), facility !== null && facility !== void 0 && facility.description ? _jsxs(List, {
            gap: "1",
            children: [_jsx(Text, _objectSpread(_objectSpread({}, facilityItemTypographyProps), {}, {
              "data-testid": "facility-title",
              children: facility === null || facility === void 0 ? void 0 : facility.name
            })), _jsx(Text, _objectSpread(_objectSpread({}, facilityItemTypographyProps), {}, {
              "data-testid": "facility-description",
              color: "darkGrey2",
              children: facility === null || facility === void 0 ? void 0 : facility.description
            }))]
          }) : _jsx(Text, _objectSpread(_objectSpread({}, facilityItemTypographyProps), {}, {
            "data-testid": "facility-title",
            children: facility === null || facility === void 0 ? void 0 : facility.name
          }))]
        }, facility === null || facility === void 0 ? void 0 : facility.code))
      }))
    }))
  }));
}
var modalStyles = {
  w: {
    base: 'calc(100vw - var(--chakra-space-3xl))',
    md: '30.375rem',
    xl: '36.875rem'
  },
  px: 6,
  py: '2xl'
};
var listStyles = {
  w: 'full',
  fontWeight: 500,
  gap: 10
};
var facilityItemSemanticTypography = {
  textStyle: 'body-m-regular'
};
var facilitiesModalTitleLegacyTypography = {
  fontSize: 'lg',
  lineHeight: '3',
  fontFamily: 'header'
};
var facilitiesModalTitleSemanticTypography = {
  textStyle: 'title-m-regular'
};